export const isPreviewMode =
(window as any)._env_.REACT_APP_IS_PREVIEW_MODE && (window as any)._env_.REACT_APP_IS_PREVIEW_MODE === 'true';

  export const isLocalMode =
  (window as any)._env_.REACT_APP_IS_LOCAL && (window as any)._env_.REACT_APP_IS_LOCAL === 'true';